// src/pages/DownloadGuide.js
/* eslint-disable */
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import HelmetTemplate from "../utils/HelmetTemplate";
import WebpageShell from "./WebpageShell";

const downloadUrl =
  "https://firebasestorage.googleapis.com/v0/b/match-medic-p0.appspot.com/o/ebooks%2Fguide2025.pdf?alt=media&token=578b770a-4d4a-40b1-8f76-934e2ff27559";

export default function DownloadGuide() {
  // Auto-start the download shortly after mount
  useEffect(() => {
    const timer = setTimeout(() => {
      window.location.href = downloadUrl;
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <WebpageShell
      navProps={{ addAnnouncementBar: false, isRecPrototypePage: false }}
      showCTA={true}
      showFooter={true}
    >
      <HelmetTemplate
        title="Download the Hair Transplant Guide"
        description="Your personalized hair transplant guide is ready for download."
        canonicalUrl="https://matchmedic.com/download-guide"
      />

      {/* Page content */}
      <div className="w-full md:w-4/5 mx-auto">
        <section className="min-h-[60vh] flex flex-col items-center justify-center px-4 py-12 text-center">
          <h1 className="text-3xl font-extrabold text-gray-900 mb-4">
            Your Guide is Ready!
          </h1>

          <p className="text-gray-700 mb-6">
            Your download will start automatically. If it doesn&apos;t,&nbsp;
            <a
              href={downloadUrl}
              className="text-mm_blue underline font-medium"
              download
            >
              click here to download manually
            </a>
            .
          </p>

          <Link
            to="/"
            className="inline-flex items-center justify-center px-6 py-2 rounded-md bg-gray-900 text-white font-semibold hover:bg-gray-800 transition"
          >
            Back to Homepage
          </Link>
        </section>
      </div>
    </WebpageShell>
  );
}
